(function ($, Drupal, once) {
  Drupal.behaviors.videoTextSlider = {
    attach(context) {
      once('video-text-slider', '.video-text-slider', context)
      .forEach(function () {
        var videoTextSlider = new Splide('#video_text_slider', {
          type: 'loop',
          perPage: 1,
          arrows: true,
          pagination: true,
          draggable: true,
        });

        const players = [];

        document.querySelectorAll('#video_text_slider iframe').forEach((iframe) => {
          players.push(new Vimeo.Player(iframe));
        });

        videoTextSlider.on('moved', function () {

          // Pause all videos
          players.forEach(player => {
            player.pause().catch(() => {});
          });
        });

        videoTextSlider.mount();
      });

    }
  };

})(jQuery, Drupal, once);
